<template>
    <InputCheckbox
        :ref="`checkbox-${$.uid}`"
        class="hidden"
        :model-value="modelValue"
        :value="value"
        :disabled="disabled"
        @update:model-value="propagate"
    />
    <Btn
        class="!font-normal !text-sm px-2 py-0.5"
        size="xs"
        :color="isChecked ? 'primary' : 'surface'"
        round
        elevated
        v-bind="$attrs"
        :icon="undefined"
        :left-icon="isChecked ? 'tick' : leftIcon"
        @click="toggle"
    />
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import InputCheckboxMixin from '@components/InputCheckbox/InputCheckboxMixin';
import InputCheckbox from '@components/InputCheckbox';

export default defineComponent({
    name: 'Chip',
    components: { InputCheckbox },
    extends: InputCheckboxMixin,
    inheritAttrs: false,
    emits: ['update:modelValue'],
    computed: {
        leftIcon(): string | undefined {
            if (this.$attrs.icon) return this.$attrs.icon as string;
            if (this.$attrs['left-icon']) return this.$attrs['left-icon'] as string;
            return undefined;
        },
    },
    methods: {
        propagate(data: boolean | []): void {
            this.$emit('update:modelValue', data);
        },
        toggle(): void {
            const checkbox = this.$refs[`checkbox-${this.$.uid}`] as HTMLElement & { triggerClick: () => void };
            checkbox.triggerClick();
        },
    },
});
</script>

<style lang="scss" scoped></style>
